import { render } from "./VoteSimulation.vue?vue&type=template&id=6f1be3fa&scoped=true"
import script from "./VoteSimulation.vue?vue&type=script&lang=js"
export * from "./VoteSimulation.vue?vue&type=script&lang=js"

import "./VoteSimulation.vue?vue&type=style&index=0&id=6f1be3fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1be3fa"]])

export default __exports__